const initState = {
    distributorId: '',
    useShipTo: '',
    showTaxId: ''
};

export const SET_DISTRIBUTOR_ID = 'SET_DISTRIBUTOR_ID';
export const SET_USE_SHIP_TO = 'SET_USE_SHIP_TO';
export const SET_SHOW_TAX_ID = 'SET_SHOW_TAX_ID';

export const setDistributorId = (data) => ({ type: SET_DISTRIBUTOR_ID, payload: data });
export const setUseShipTo = (data) => ({ type: SET_USE_SHIP_TO, payload: data });
export const setShowTaxId = (data) => ({ type: SET_SHOW_TAX_ID, payload: data });

export default (state = initState, action) => {
    switch (action.type) {
        case SET_DISTRIBUTOR_ID:
            return { ...state, distributorId: action.payload };
        case SET_USE_SHIP_TO:
            return { ...state, useShipTo: action.payload };
        case SET_SHOW_TAX_ID:
            return { ...state, showTaxId: action.payload };
        default:
            return state
    }
}